<template>
  <v-list
    class="payment-list"
    :class="cat"
    two-line
  >
    <div
      v-for="(item, i) in list"
      :key="i"
    >
      <v-expand-transition>
        <Form
          v-if="(selected.UUID === item.UUID && selected.UUID !== 0)"
          :value="item"
          :cat="cat"
          :debt="debt"
          @closed="close_"
          @saved="save_"
        />
        <v-list-item v-else :class="{ 'deleted': (item.id > 0 && item.delete > 0)}">
          <v-list-item-icon>
            <v-icon color="deep-orange">mdi-cash-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.title" />
            <v-list-item-subtitle v-text="formatCurrency(item.value)" />
          </v-list-item-content>
          <v-list-item-action v-if="item.type !== 0">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click.stop="edit_(item)"
                  icon small
                >
                  <v-icon small color="orange">mdi-circle-edit-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ lang.orders.new.payment.actions.edit }}</span>
            </v-tooltip>
            <v-tooltip left v-if="item.id > 0 && item.delete > 0 && item.cat === 'paid'">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click.stop="restore_(item.UUID)"
                  icon small
                >
                  <v-icon small color="green lighten-2">mdi-backup-restore</v-icon>
                </v-btn>
              </template>
              <span>{{ lang.orders.new.payment.actions.restore }}</span>
            </v-tooltip>
            <v-tooltip left v-else>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @dblclick.stop="delete_(item.UUID)"
                  icon small
                >
                  <v-icon small color="red lighten-1">mdi-close-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ lang.orders.new.payment.actions.delete }}</span>
            </v-tooltip>
            <!-- <v-btn
              @click.stop="edit_(item)"
              icon small
            >
              <v-icon small color="orange lighten-1">mdi-circle-edit-outline</v-icon>
            </v-btn>
            <v-btn
              @dblclick.stop="delete_(item.UUID)"
              icon small
            >
              <v-icon small color="red lighten-1">mdi-close-circle-outline</v-icon>
            </v-btn> -->
          </v-list-item-action>
        </v-list-item>
      </v-expand-transition>
    </div>
    <v-expand-transition>
      <Form
        v-if="selected.UUID === 0"
        :value="selected"
        :cat="cat"
        :debt="debt"
        @closed="close_"
        @saved="save_"
      />
      <v-tooltip v-else-if="selected.UUID === -1" right>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            @click.prevent="new_()"
            color="green"
            app
            fab
            bottom
            right
            x-small
            class="add-btn"
          >
            <v-icon x-small dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>{{ lang.orders.new.payment[cat].add }}</span>
      </v-tooltip>
    </v-expand-transition>
  </v-list>
</template>

<script>
import Form from './Form'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { Form },
  mixins: [ appdata, utils ],
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    cat: {
      type: String,
      required: true
    },
    debt: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      selected: { ...defaults.blank.payment },
      list: [ ...this.value ]
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler (newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.payment)) this.list = [ ...newVal ]
      }
    },
    list: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.value)) this.$emit('input', newVal)
      }
    }
  },
  methods: {
    new_ () {
      this.selected = {
        id: 0,
        UUID: 0,
        cat: this.cat,
        type: 1,
        title: '',
        value: 0,
        percent: 10,
        parcels: 1,
        delete: 0
      }
    },
    edit_ (item) {
      this.selected = { ...item }
    },
    delete_ (UUID) {
      let list = this.list,
          index = list.findIndex(a => a.UUID === UUID),
          item = list[index]
      if (index >= 0) {
        if (item.id > 0) {
          item.delete = 1
        } else {
          list.splice(index, 1)
        }
        this.$set(this, 'list', list)
      }
    },
    restore_ (UUID) {
      let list = this.list,
          index = list.findIndex(a => a.UUID === UUID),
          item = list[index]
      if (index >= 0 && item.id > 0) {
        item.delete = 0
        this.$set(this, 'list', list)
      }
    },
    close_ () {
      this.selected = { ...defaults.blank.payment }
    },
    save_ (selected) {
      let list = this.list
      if (selected.UUID <= 0) {
        selected.UUID = this.getRandomUnique()
        list.push(selected)
        this.$set(this, 'list', list)
      } else {
        let index = list.findIndex(a => a.UUID === selected.UUID)
        if (index >= 0) this.$set(this.list, index, { ...selected })
      }
      this.close_()
      return true
    }
  }
}
</script>

<style>

</style>